import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch as spinner } from "@fortawesome/pro-light-svg-icons";

const SpinnerIcon = ({ className = "", ...rest }) => {
  return <FontAwesomeIcon icon={spinner} {...rest} className={className} />;
};

export default SpinnerIcon;
